// Helper utility to load and initialize Google Tag Manager (GTM) and Google Analytics (GA4) dynamically with fallback IDs

declare global {
  interface Window {
    dataLayer?: any[];
    gtag?: (...args: any[]) => void;
  }
}

export function initGoogleServices() {
  // Read configured environment variables with the fallback legacy IDs if not set
  const gtmId = (
    import.meta.env.VITE_GTM_ID || 
    import.meta.env.VITE_GTM_CONTAINER_ID || 
    import.meta.env.VITE_GTM_CONTAINE || 
    'GTM-59F4D3N4'
  ).trim();

  const gaId = (
    import.meta.env.VITE_GA_MEASUREMENT_ID || 
    import.meta.env.VITE_GA_MEASUREMENT || 
    'G-V1SH2E7GKY'
  ).trim();

  // Ensure global tracking queues are initialized
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = function (...args: any[]) {
      window.dataLayer?.push(args);
    };
  }

  // 1. Dynamically Inject Google Tag Manager (GTM)
  if (gtmId && !document.getElementById('gtm-script')) {
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });

    const script = document.createElement('script');
    script.id = 'gtm-script';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    document.head.appendChild(script);
  }

  // 2. Dynamically Inject Google Analytics 4 (gtag.js)
  if (gaId && !document.getElementById('ga-script')) {
    const script = document.createElement('script');
    script.id = 'ga-script';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(script);

    // Configure tracking parameters
    if (typeof window.gtag === 'function') {
      window.gtag('js', new Date());
      window.gtag('config', gaId, {
        send_page_view: false // Prevent double tracking since we trigger page_view manually on route changes
      });
    }
  }
}
